export default __webpack_public_path__ + "static/media/slider6.5afccdea.jpeg";